<template>
  <div class="c-pkg-item">
    <img
      class="cpi-tag"
      v-if="pkg.tag === 'recommend'"
      src="@/assets/images/price/ico-hot.png"
      alt=""
    />
    <div class="cpi-name">{{ pkg.name }}</div>
    <div class="cpi-desc">{{ pkg.desc }}</div>
    <div class="cpi-price">
      <span class="num">{{ pkg.price }}</span>
      <span class="unit">{{ pkg.priceUnit }}</span>
      <span class="limit">({{ pkg.priceLimit }})</span>
      <!-- <div class="cpi-price-limit">({{ pkg.priceLimit }})</div> -->
    </div>
    <div class="cpi-split"></div>
    <div
      class="cpi-price-feature"
      v-for="(item, index) in pkg.feature"
      :key="index"
    >
      <img class="cpi-price-feature__icon" :src="item.icon" alt="" />
      <span class="cpi-price-feature__text">{{ item.text }}</span>
    </div>

    <div v-if="pkg.disabled" class="btn disabled-btn">
      {{ pkg.mainButtonText }}
    </div>
    <kd-button
      v-else
      class="btn"
      :class="pkg.tag === 'recommend' ? 'primary-btn' : 'black-border-btn'"
      @click="contactSales"
    >
      {{ pkg.mainButtonText }}
    </kd-button>
  </div>
</template>

<script>
import { getFromPage, getPageName } from "@/common/utils/index";
import infoCollect from "@/common/infoCollect";

export default {
  name: "PackageComponent",
  props: {
    pkg: Object,
    isLiuziPage: Boolean,
  },
  data() {
    return {};
  },
  inject: ["getChannel"],
  computed: {
    channel() {
      return this?.getChannel()
    },
  },
  methods: {
    contactSales() {
      if (this.isLiuziPage) {
        infoCollect.dwCollectData(
          "button_click",
          "buy_" + this.pkg.type,
          "PC",
          {
            page_name: "pay_sales_retention",
            client_channel: this.channel,
          },
        );
      } else {
        infoCollect.dwCollectData("button_click", this.pkg.event, "PC", {
          page_name: getPageName(),
          from_item: getFromPage(),
        });
      }

      const { mainButtonUrl } = this.pkg || {};

      if (this.isLiuziPage) {
        window.open(mainButtonUrl, "_self");
        return;
      }

      window.open(mainButtonUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
.c-pkg-item {
  display: inline-block;
  width: 282px;
  height: 545px;
  background: #ffffff;
  box-shadow: 0px 4px 30px rgba(116, 134, 163, 0.1),
    0px 1px 2px rgba(116, 134, 163, 0.04);
  border-radius: 16px;
  padding: 20px;
  position: relative;

  // @include screen_xs {
  //   width: 264px;
  // }

  // @include screen_s {
  //   width: 264px;
  // }

  // @include screen_m {
  //   width: 264px;
  // }

  // @include screen_l {
  //   width: 264px;
  // }

  // @include screen_xl {
  //   width: 264px;
  // }

  .cpi-tag {
    top: 0px;
    right: 12px;
    position: absolute;
    width: 22px;
    height: 32px;
  }
  .cpi-name {
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    color: rgba(13, 13, 13, 0.9);
    text-align: left;
  }

  .cpi-desc {
    font-size: 12px;
    line-height: 22px;
    margin-top: 12px;
    color: rgba(13, 13, 13, 0.66);
    text-align: left;
  }

  .cpi-price {
    display: flex;
    font-size: 14px;
    line-height: 48px;
    margin-top: 22px;
    color: rgba(13, 13, 13, 0.9);
    position: relative;
    height: 36px;

    span {
      vertical-align: bottom;
    }

    .num {
      font-size: 36px;
      font-weight: 700;
      line-height: 36px;
      margin-right: 10px;
    }

    .limit {
      font-size: 14px;
      line-height: 48px;
      font-weight: 400;
      position: absolute;
      right: 0;
      color: rgba(13, 13, 13, 0.66);
    }
  }

  .cpi-split {
    margin-top: 24px;
    width: 100%;
    height: 1px;
    background: rgba(13, 13, 13, 0.9);
    opacity: 0.1;
    margin-bottom: 33px;
  }

  .cpi-price-feature {
    margin-bottom: 18px;
    position: relative;
    display: flex;
    align-items: center;

    &__icon {
      display: block;
      width: 22px;
      height: 22px;
      margin-right: 8px;
      margin-top: 0px;
    }

    &__text {
      height: 22px;
      line-height: 22px;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .btn {
    height: 48px;
    text-align: center;
    font-weight: 600;
    position: absolute;
    left: 40px;
    right: 40px;
    bottom: 40px;
    margin: 0 auto;
    font-size: 16px;
    font-weight: 600;
    border-radius: 8px;
    width: calc(100% - 80px);
  }

  .disabled-btn {
    background-color: rgb(242, 242, 242);
    line-height: 48px;
  }
}
</style>
